import {Component, Inject, OnInit} from '@angular/core';

import {ActivatedRoute, Router} from '@angular/router';

import {MatDatepickerInputEvent} from '@angular/material/datepicker';
import * as moment from "moment";

import {LoginHelper, Recurring, Role, StringsHelper,} from '../../helpers';

import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';

import {
  AlertService,
  AuthenticationService,
  ClientProfileService,
  ComplianceAreaService,
  ProjectService,
  TenantService,
  UserService
} from '../../_services';

import {ClientITProfile, ComplianceArea, Project, User} from '../../_models';

import {TreeNode} from 'primeng/api';
import {ConfirmComponent} from "../confirm";
import {WorkstreamService} from "../../_services/workstream.service";
import {forkJoin} from "rxjs";
import {ActionItemService} from "../../_services/actionItem.service";
import {ImplementationControlStatementService} from "../../_services/implementationControlStatement.service";
import { FleetsService } from '../../_services/fleets.service';
import { Fleet } from '../../_models/fleet.models';

const now = new Date();

@Component({
    standalone: false,
  selector: 'project-properties-component',
  templateUrl: 'project.properties.component.html',
  styleUrls: ['./project.properties.component.scss'],
})

export class ProjectPropertiesComponent implements OnInit {
  loading = false;
  project: Project;
  currentUser: User;

  allUsers: User[];
  clients: User[];
  clientManagers: User[];
  partners: User[];
  assessors: User[];
  workstreamUsers: User[];
  advisors: User[];
  advisorLeads: User[];
  projectReadOnly: boolean = true;
  maxLevel: any = '1';
  hasLeveledSubItems: boolean = false;
  itProfiles: ClientITProfile[];
  selectedItProfile?: ClientITProfile[];
  canDelete: boolean = false;
  actionPlanTemplateSets = [];
  implementationControlStatementSets = [];

  isDeleting: boolean = false;
  assignedClients: number[];
  assignedClientManagers: number[];
  assignedConsultants: number[];
  assignedConsultantManagers: number[];
  assignedUsers: number[];
  assignedUsersWithoutPartners: User[];
  assignedAssessors: number[];
  assignedWorkstreamUsers: number[];
  assignedVendors: User[];
  complianceAreas: TreeNode[];
  recurringList: any[];
  isPartner: boolean;
  selectedItems: any[] = [];
  oldIds = [];
  withFileIds = [];
  projectLoaded = false;
  lowPart = {};
  mediumPart = {};
  highPart = {};
  low = {};
  medium = {};
  high = {};
  hasPart = {};
  hasRank = {};
  recommendedControlIds = [];
  hasParents = false;
  levels = [];
  workstreams = [];
  fleets: Fleet[] = [];
  isAutonomyEnabled: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ProjectPropertiesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public router: Router,
    public route: ActivatedRoute,
    public projectService: ProjectService,
    public complianceAreaService: ComplianceAreaService,
    public userService: UserService,
    public alertService: AlertService,
    public authenticationService: AuthenticationService,
    public dialog: MatDialog,
    public workstreamService: WorkstreamService,
    public actionItemService : ActionItemService,
    public implementationControlStatementService : ImplementationControlStatementService,
    public clientProfileService: ClientProfileService,
    public fleetsService: FleetsService,
    public tenantService: TenantService,  ) {
  }

  ngOnInit() {

    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }
    this.project = Object.assign({}, this.data.project);
    this.oldIds = this.project.projectControlItems.map(i => i.controlItem.controlItemId);
    this.withFileIds = this.project.projectControlItems.filter(p => (p.attachments.length > 0 || p.evidences.find(e => !(e.name || '').startsWith('http://') && !(e.name || '').startsWith('https://') && !(e.name || '').startsWith('\\\\')) !== undefined)
      || p.assessmentNotes.find(n => n.attachments.length > 0) !== undefined).map(i => i.controlItem.controlItemId);
    console.log(this.withFileIds);
    this.currentUser = JSON.parse(sessionStorage.getItem('currentUser'));
    this.projectReadOnly = (this.currentUser.role & Role.Assessor) != 0;
    this.isPartner = this.currentUser.role == Role.Vendor;
    this.canDelete = (this.currentUser.role & (Role.PrimaryManager | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0;


    this.recurringList = [];
    for (let i = 0; i <= Recurring.Yearly; i++) {

      this.recurringList.push({label: Recurring[i].toString(), value: i});
    }

    this.tenantService.getCurrent().subscribe(p => {
      this.isAutonomyEnabled = p.isAutonomyEnabled;
    });

    forkJoin([this.userService.getAll(),
      this.complianceAreaService.getComplianceAreasProjectControlItems(this.project.projectId)]).subscribe((data) => {
      let projectControlItems;
      this.projectLoaded = true;
      const users = data[0];
      this.allUsers = users;
      this.allUsers.map(u => {
        u.fullName = (u.firstName || u.lastName) ? u.firstName + " " + u.lastName : u.emailAddress;
      })

      this.workstreamService.getWorkstreams().subscribe((workstreams) => {
        this.workstreams = workstreams;
      });

      this.project.assignedUsers = this.project.assignedUsers.map(u => users.find(uu => uu.userId == u.userId)).filter((value, index, self) => self.indexOf(value) === index);
      this.assignedClientManagers =
        this.project.assignedUsers
          .filter(user => (user.role & (Role.Manager | Role.PrimaryManager)) != 0)
          .map(x => x.userId);

      this.assignedConsultantManagers =
        this.project.assignedUsers
          .filter(user => (user.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0)
          .map(x => x.userId);

      this.assignedClients =
        this.project.assignedUsers
          .filter(user => (user.role & Role.User) != 0)
          .map(x => x.userId);

      this.assignedConsultants =
        this.project.assignedUsers
          .filter(user => (user.role & Role.AdvisorStaff) != 0)
          .map(x => x.userId);

      this.assignedVendors =
        this.project.assignedUsers
          .filter(user => (user.role & Role.Vendor) != 0)
      ;
      this.assignedAssessors =
        this.project.assignedUsers
          .filter(user => (user.role & Role.Assessor) != 0)
          .map(x => x.userId);
      this.assignedWorkstreamUsers =
        this.project.assignedUsers
          .filter(user => (user.role & Role.Engineer) != 0)
          .map(x => x.userId);
      const complianceAreas: ComplianceArea[] = data[1];
      this.clients = users.filter(user => (user.role & Role.User) != 0);
      this.advisors = users.filter(user => (user.role & Role.AdvisorStaff) != 0);

      this.advisorLeads = users.filter(user => (user.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0)/*.filter(usr => usr.userId != this.currentUser.userId)*/;
      this.clientManagers = users.filter(user => (user.role & (Role.Manager | Role.PrimaryManager)) != 0)/*.filter(usr => usr.userId != this.currentUser.userId)*/;

      this.partners = users.filter(user => (user.role & Role.Vendor) != 0);
      this.assessors = users.filter(user => (user.role & Role.Assessor) != 0);
      this.workstreamUsers = users.filter(user => (user.role & Role.Engineer) != 0);

      /*if ((this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0) {
        this.advisorLeads = [this.currentUser];
      } else {
        this.clientManagers = [this.currentUser];
      }*/

      let defaultClient;
      if (this.assignedClientManagers.length > 0) {
        defaultClient = this.allUsers.find(u => u.userId == this.assignedClientManagers[0]);
      } else if (this.assignedConsultantManagers.length > 0) {
        defaultClient = this.allUsers.find(u => u.userId == this.assignedConsultantManagers[0]);
      }


      this.complianceAreas = complianceAreas;
      this.maxLevel = "L1";
      for (let complianceArea of complianceAreas) {
        this.low[complianceArea.complianceAreaId] = undefined;
        this.medium[complianceArea.complianceAreaId] = undefined;
        this.high[complianceArea.complianceAreaId] = undefined;
        if (complianceArea.data.checked) this.selectedItems.push(complianceArea);
        for (let category of complianceArea.children) {
          if (category.data.checked) this.selectedItems.push(category);
          for (let subCategory of category.children) {
            (<any>subCategory).originalChecked = subCategory.data.checked;
            if (subCategory.children == null) {
              this.low[complianceArea.complianceAreaId] = (this.low[complianceArea.complianceAreaId] || this.low[complianceArea.complianceAreaId] === undefined) && (!subCategory.isLow || subCategory.data.checked);
              this.medium[complianceArea.complianceAreaId] = (this.medium[complianceArea.complianceAreaId] || this.medium[complianceArea.complianceAreaId] === undefined) && (!subCategory.isMedium || subCategory.data.checked);
              this.high[complianceArea.complianceAreaId] = (this.high[complianceArea.complianceAreaId] || this.high[complianceArea.complianceAreaId] === undefined) && (!subCategory.isHigh || subCategory.data.checked);
            }
            if (subCategory.data.checked) {
              this.selectedItems.push(subCategory);
              if (complianceArea.hasLevels && this.maxLevel < subCategory.level && this.project.projectControlItems.find(x => x.controlItem.controlItemId == subCategory.controlItemId)) {
                this.maxLevel = subCategory.level;
              }
              if (subCategory.subItems) {
                subCategory.subItems.forEach(i => {
                  if (this.maxLevel < i.level && this.project.projectControlItems.find(x => x.controlItem.controlItemId == i.controlItemId)) {
                    this.maxLevel = i.level;
                  }
                });
              }
            }

            const subCategoryData = subCategory.data;

            if (subCategory.children != null) {

              for (let controlItem of subCategory.children) {
                this.hasRank[complianceArea.complianceAreaId] = this.hasRank[complianceArea.complianceAreaId] || controlItem.isHigh || controlItem.isMedium || controlItem.isLow;
                (<any>controlItem).originalChecked = controlItem.data.checked;
                this.low[complianceArea.complianceAreaId] = this.low[complianceArea.complianceAreaId] && (!controlItem.isLow || controlItem.data.checked);
                this.medium[complianceArea.complianceAreaId] = this.medium[complianceArea.complianceAreaId] && (!controlItem.isMedium || controlItem.data.checked);
                this.high[complianceArea.complianceAreaId] = this.high[complianceArea.complianceAreaId] && (!controlItem.isHigh || controlItem.data.checked);
                if (controlItem.data.checked) {
                  this.selectedItems.push(controlItem);
                  if (complianceArea.hasLevels && this.maxLevel < controlItem.level && this.project.projectControlItems.find(x => x.controlItem.controlItemId == controlItem.controlItemId)) {
                    this.maxLevel = controlItem.level;
                  }
                  if (controlItem.subItems) {
                    controlItem.subItems.forEach(i => {
                      if (this.maxLevel < i.level && this.project.projectControlItems.find(x => x.controlItem.controlItemId == i.controlItemId)) {
                        this.maxLevel = i.level;
                      }
                    });
                  }
                }
                const controlItemData = controlItem.data;
                //controlItemData.disabled = controlItemData.checked;
                if (!subCategoryData.checked) {
                  controlItemData.dueDate = this.project.dueDate;
                  controlItemData.assignedClientList = [defaultClient];
                } else {
                  projectControlItems = this.project.projectControlItems.filter(i => i.controlItem.controlItemId == controlItemData.controlItemId);
                  projectControlItems.forEach(i => i.dueDate = <any>moment.utc(i.dueDate).format('YYYY-MM-DDT00:00:00'))
                  controlItemData.assignedClientList = this.project.assignedUsers.filter(x => projectControlItems.find(a => a.assignedClient.userId == x.userId));
                  if (projectControlItems.length) {
                    controlItemData.reviewRequired = projectControlItems[0].reviewRequired;
                    controlItemData.dueDate = projectControlItems[0].dueDate;
                  }
                }
              }
            }

            this.hasRank[complianceArea.complianceAreaId] = this.hasRank[complianceArea.complianceAreaId] || subCategory.isHigh || subCategory.isMedium || subCategory.isLow;

            if (subCategoryData.controlItemId) {
              if (!subCategoryData.checked) {
                const c = this.clients.find(x => x.userId == this.assignedClients[0]);
                subCategoryData.dueDate = this.project.dueDate;
                subCategoryData.assignedClientList = [defaultClient];
              } else {
                this.selectedItems.push(subCategory);
                projectControlItems = this.project.projectControlItems.filter(i => i.controlItem.controlItemId == subCategoryData.controlItemId);
                projectControlItems.forEach(i => i.dueDate = <any>moment.utc(i.dueDate).format('YYYY-MM-DDT00:00:00'))
                subCategoryData.assignedClientList = this.project.assignedUsers.filter(x => projectControlItems.find(a => a.assignedClient.userId == x.userId));
                if (projectControlItems.length) {
                  subCategoryData.dueDate = projectControlItems[0].dueDate;
                  subCategoryData.reviewRequired = projectControlItems[0].reviewRequired;
                  if (subCategory.subItems) {
                    subCategory.subItems.forEach(i => {
                      if (this.maxLevel < i.level && this.project.projectControlItems.find(x => x.controlItem.controlItemId == i.controlItemId)) {
                        this.maxLevel = i.level;
                      }
                    });
                  }
                }
              }

            }
          }
          //var categoryData = category.data;
        }
        //var complianceAreaData = complianceArea.data;
      }

      this.selectedItems = Array.from(new Set(this.selectedItems));
      this.updateAssignedUsers();

      this.initSelection(this.complianceAreas);
      this.updateLeveledSelection(false, false);
      this.updateLevel();
      complianceAreas.forEach(i => this.checkTopLevel(i));
    });


    this.clientProfileService.getClientProfiles(tenantName).subscribe(c => {
      this.itProfiles = c;
      if (c.length && this.project.clientITProfileIds) {
        this.selectedItProfile = this.project.clientITProfileIds.split(';').map(i => c.find(p => p.clientITProfileId == i)).filter(p => p);
      } else {
        this.selectedItProfile = []
      }
      this.updateRecommendedControls();
    });

    this.actionItemService.getAllActionItemTemplateSets().subscribe(s => this.actionPlanTemplateSets = s);
    this.implementationControlStatementService.getAllImplementationControlStatementSets().subscribe(s => this.implementationControlStatementSets = s);

    this.fleetsService.getAll().subscribe({
      next: fleets => {
        this.fleets = fleets;
      }
    });
  }

  isConsultantManager() {
    return (this.currentUser.role & (Role.AdvisorLead | Role.PrimaryAdvisorLead | Role.PlatformSupport)) != 0
  }

  isClientManager() {
    return (this.currentUser.role & (Role.Manager | Role.PrimaryManager)) != 0
  }

  onClose(): void {
    this.dialogRef.close();
  }

  onSave() {

    let data;
    let i = 0;
    let item;
    let subItem;
    let subitem;
    if (this.project.name == null ||
      this.project.name == '' ||
      (this.assignedClients.length == 0 &&
        this.assignedClientManagers.length == 0 &&
        this.assignedConsultants.length == 0 &&
        this.assignedConsultantManagers.length == 0) ||
      this.project.dueDate == null) {

      const errorMessage = 'You should fill all required fields.';
      this.alertService.error(errorMessage);
      return;
    }

    this.loading = true;

    let users = [];
    users = users.concat(this.assignedConsultants.map(x => {
      const user = new User(x);
      user.role = Role.AdvisorStaff;
      return user;
    }));

    users = users.concat(this.assignedClients.map(x => {
      const user = new User(x);
      user.role = Role.User;
      return user;
    }));

    users = users.concat(this.assignedConsultantManagers.map(x => {
      const user = new User(x);
      user.role = Role.AdvisorLead;
      return user;
    }));

    users = users.concat(this.assignedClientManagers.map(x => {
      const user = new User(x);
      user.role = Role.Manager;
      return user;
    }));

    users = users.concat(this.assignedAssessors.map(x => {
      const user = new User(x);
      user.role = Role.Assessor;
      return user;
    }));

    users = users.concat(this.assignedWorkstreamUsers.map(x => {
      const user = new User(x);
      user.role = Role.Engineer;
      return user;
    }));

    if (this.project.isPartner) {
      users = users.concat(this.assignedVendors.map(x => {
        const user = new User(x.userId);
        user.role = Role.Vendor;
        return user;
      }));
    }

    this.project.assignedUsers = users.filter(function (item, pos) {
      return users.indexOf(item) == pos
    });

    const selectedControlItems: any[] = [];

    for (let complianceArea of this.complianceAreas) {
      for (let category of complianceArea.children) {
        for (let subCategory of <any[]>category.children) {

          if (subCategory.children != null) {
            for (let controlItem of <any[]>subCategory.children) {
              if (this.selectedItems.indexOf(controlItem) >= 0
                && controlItem.data.controlItemId != 0) {

                data = controlItem.data;
                data.recurring = data.recurring == null ? 0 : data.recurring.value;
                for (i = 0; i < data.assignedClientList.length; i++) {
                  item = Object.assign({}, data);
                  let anySubitem = true;
                  if (controlItem.subItems && controlItem.subItems.length) {
                    anySubitem = false;
                    for (let j = 0; j < controlItem.subItems.length; j++) {
                      subItem = controlItem.subItems[j];
                      if (subItem.level <= this.maxLevel || !(<any>complianceArea).hasLevels) {
                        subitem = Object.assign({}, subItem);
                        subItem.dueDate = item.dueDate;
                        subitem.assignedClient = data.assignedClientList[i];
                        selectedControlItems.push(subitem);
                        anySubitem = true;
                      }
                    }
                  }
                  item.assignedClient = data.assignedClientList[i];
                  item.reviewRequired = data.reviewRequired;
                  if (anySubitem) {
                    selectedControlItems.push(item);
                  }
                }
              }
            }
          }

          if (this.selectedItems.indexOf(subCategory) >= 0
            && subCategory.data.controlItemId != 0) {

            data = subCategory.data;
            data.recurring = data.recurring == null ? 0 : data.recurring.value;

            for (i = 0; i < data.assignedClientList.length; i++) {
              item = Object.assign({}, data);
              let anyOrNoneSub = true;
              if (subCategory.subItems && subCategory.subItems.length) {
                anyOrNoneSub = false;
                for (let j = 0; j < subCategory.subItems.length; j++) {
                  subItem = subCategory.subItems[j];
                  if (subItem.level <= this.maxLevel || !(<any>complianceArea).hasLevels) {
                    subitem = Object.assign({}, subItem);
                    subItem.dueDate = item.dueDate;
                    subitem.assignedClient = data.assignedClientList[i];
                    selectedControlItems.push(subitem);
                    anyOrNoneSub = true;
                  }
                }
              }
              item.assignedClient = data.assignedClientList[i];
              item.reviewRequired = data.reviewRequired;
              if (anyOrNoneSub) {
                selectedControlItems.push(item);
              }
            }
          }
        }
      }
    }

    //selectedControlItems = selectedControlItems.filter(c => !c.level || c.level < this.maxLevel || !selectedControlItems.find(i => i.controlItemId == c.parentControlItemId));
    const newIds = selectedControlItems.map(i => i.controlItemId);
    this.project.projectControlItems = selectedControlItems;
    this.project.clientITProfileIds = this.selectedItProfile.map(p => p.clientITProfileId).join(';');
    this.project.tenantName = LoginHelper.getTenantName();
    const deletedIds = this.oldIds.filter(g => newIds.indexOf(g) < 0)
    console.log(this.oldIds);
    console.log(newIds);
    console.log(deletedIds);
    if (deletedIds.find(p => this.withFileIds.indexOf(p) >= 0)) {
      this.dialog.open(ConfirmComponent, {
        data: {
          title: 'Would you like to preserve attachements in the Document Libary?',
          yes: 'Yes',
          no: 'No',
          confirm: () => this.doOnSave(false),
          cancel: () => this.doOnSave(true)
        }
      })
    } else {
      this.doOnSave(false);
    }
  }

  doOnSave(withFiles) {
    this.projectService.update(this.project, withFiles)
      .subscribe(
        data => {
          this.alertService.success('The project was updated.', true);
          this.onClose();
        },
        error => {

          this.loading = false;
          this.alertService.error(error);
        });

    this.loading = false;
  }

  checkTopLevel(item: any): boolean {
    let all = true;
    if (!item.children) return item.data.checked;
    for (let i = 0; i < item.children.length; i++) {
      if (!this.checkTopLevel(item.children[i]) && !item.children[i].data.checked) all = false;
    }
    if (all) {
      this.selectedItems.push(item);
      this.selectedItems = Array.from(new Set(this.selectedItems));
    }
    return all;
  }

  getFullName(user: User) {

    return StringsHelper.getFullName(user);
  }

  getFullNameId(id: number) {

    return StringsHelper.getFullName(this.allUsers.find(u => u.userId == id));
  }

  onNodeRecurringChanged(event, value, node) {

    if (node.parent != null) {
      node.parent.data.recurring = null;
    }

    const dateNow = value.value != Recurring.None
      ? new Date(Date.now())
      : null;

    this.nodeRecurringChanged(event, value, node, dateNow);
  }

  nodeRecurringChanged(event, value, node, startDate) {

    node.data.recurring = value;
    node.data.startDate = startDate;

    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.nodeRecurringChanged(event, value, child, startDate);
    }
  }

  onNodeClientChanged(event, value, node) {
    node.data.assignedClientList = value;

    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.onNodeClientChanged(event, value, child);
    }
  }

  onNodeStartDateChanged(type: string, event: MatDatepickerInputEvent<Date>, node) {
    node.data.startDate = event.value;

    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.onNodeStartDateChanged(type, event, child);
    }
  }

  deleteProject() {
    this.isDeleting = true;
    if (this.withFileIds.length > 0) {
      this.dialog.open(ConfirmComponent, {
        data: {
          title: 'Do you wish to keep associated attachment and evidence?',
          yes: 'Yes',
          no: 'No',
          confirm: () => this.doDeleteProject(false),
          cancel: () => this.doDeleteProject(true)
        }
      })
    } else {
      this.doDeleteProject(false)
    }
  }

  doDeleteProject(withFiles) {
    this.projectService.delete(this.project.projectId, withFiles).subscribe(data => {

        this.isDeleting = false;

        const message = 'The project was deleted.';
        this.alertService.success(message);

        this.router.navigate(["/"]);
        this.dialogRef.close(false);
      },

      error => {
        console.log(error);

        this.isDeleting = false;

        const errorMessage = 'An error occurred while deleting project.';
        this.alertService.error(errorMessage);
      });
  }

  onNodeDateChanged(type: string, event: MatDatepickerInputEvent<Date>, node) {
    node.data.dueDate = moment(event.value).toISOString();// timezone

    if (node.children == null) {
      return;
    }

    for (let child of node.children) {
      this.onNodeDateChanged(type, event, child);
    }
  }

  selectAllPartners(event, value, node) {
    node.data.assignedClientList = node.data.assignedClientList.concat(this.partners);
    this.onNodeClientChanged(event, value, node);
    this.updateAssignedUsers();
  }

  updateAssignedUsers() {
    let userList = this.assignedClients.concat(this.assignedClientManagers).concat(this.assignedConsultants).concat(this.assignedConsultantManagers).concat(this.assignedAssessors).concat(this.assignedWorkstreamUsers);
    this.assignedUsersWithoutPartners = userList.map(id => this.allUsers.find(u => u.userId == id));
    if (this.project.isPartner) userList = userList.concat(this.assignedVendors.map(p => p.userId));
    this.project.assignedUsers = userList.map(id => this.allUsers.find(u => u.userId == id));
    this.project.assignedUsers.map(x =>
      x.fullName =
        (x.firstName || x.lastName)
          ? x.firstName + ' ' + x.lastName
          : x.emailAddress
    );

    //this.onClientsChange();
  }

  changeReviewRequiredChecked(value, node) {
    node.data.reviewRequired = value;
    if (!node.children) return;
    for (let i = 0; i < node.children.length; i++) {
      this.changeReviewRequiredChecked(value, node.children[i]);
    }
  }

  lowChanged(complianceArea, $event) {
    this.low[complianceArea.complianceAreaId] = $event.checked;
    this.setSelection(complianceArea);
  }

  mediumChanged(complianceArea, $event) {
    this.medium[complianceArea.complianceAreaId] = $event.checked;
    this.setSelection(complianceArea);
  }

  highChanged(complianceArea, $event) {
    this.high[complianceArea.complianceAreaId] = $event.checked;
    this.setSelection(complianceArea);
  }

  setSelection(complianceArea) {
    for (let category of complianceArea.children) {
      for (let subCategory of <any[]>category.children) {

        if (subCategory.children != null) {

          for (let controlItem of <any[]>subCategory.children) {
            if (controlItem.isLow || controlItem.isMedium || controlItem.isHigh) {
              if (controlItem.isLow && this.low[complianceArea.complianceAreaId] || controlItem.isMedium && this.medium[complianceArea.complianceAreaId] || controlItem.isHigh && this.high[complianceArea.complianceAreaId]) {
                this.selectedItems.push(controlItem);
              } else {
                if (!controlItem.originalChecked) {
                  this.selectedItems = this.selectedItems.filter(i => i != controlItem);
                }
              }
            }
          }
        }
        if (subCategory.isLow || subCategory.isMedium || subCategory.isHigh)
          if (subCategory.isLow && this.low[complianceArea.complianceAreaId] || subCategory.isMedium && this.medium[complianceArea.complianceAreaId] || subCategory.isHigh && this.high[complianceArea.complianceAreaId]) {
            this.selectedItems.push(subCategory);
          } else {
            if (!subCategory.originalChecked) {
              this.selectedItems = this.selectedItems.filter(i => i != subCategory);
            }
          }
      }
    }
    this.selectedItems = [...this.selectedItems];
    this.selectedItems = Array.from(new Set(this.selectedItems));
    this.initSelection([complianceArea]);
  }

  initSelection(nodes): { all: boolean, some: boolean } {
    const result = {all: true, some: false};
    for (let i = 0; i < nodes.length; i++) {
      if (nodes[i].children && nodes[i].children.length) {
        //nodes[i].data.disabled = true;
        const childStatus = this.initSelection(nodes[i].children);
        if (childStatus.all) {
          this.selectedItems.push(nodes[i]);
          nodes[i].partialSelected = false;
        } else {
          this.selectedItems = this.selectedItems.filter(v => v != nodes[i]);
          result.all = false;
        }
        if (childStatus.some && !childStatus.all) {
          nodes[i].partialSelected = true;
        }
        if (!childStatus.some) {
          nodes[i].partialSelected = false;
        }
        result.some = result.some || childStatus.some;
      }
      if (this.selectedItems.indexOf(nodes[i]) >= 0 || nodes[i].partialSelected) {
        result.some = true;
      } else {
        result.all = false;
      }

    }
    return result;
  }

  notTenant(users) {
    if (!users)
      return [];
    return users;
  }

  updateLevel() {
    let anyWithLabel = false;
    let hasParents = false;

    for (let complianceArea of this.complianceAreas) {
      for (let category of complianceArea.children) {
        for (let subCategory of <any[]>category.children) {

          if (subCategory.children != null) {

            for (let controlItem of <any[]>subCategory.children) {
              if (this.selectedItems.indexOf(controlItem) >= 0) {
                if ((<any>complianceArea).hasLevels) {
                  anyWithLabel = true;
                }
                if (controlItem.data.subItems && controlItem.data.subItems.length) {
                  anyWithLabel = anyWithLabel || (<any>complianceArea).hasLevels || controlItem.data.subItems.find(s => s.complianceArea.hasLevels);
                  hasParents = true;
                }
              }
            }
          }
          if (this.selectedItems.indexOf(subCategory) >= 0 && subCategory.data.controlItemId != 0) {
            const data = subCategory;

            if (this.selectedItems.indexOf(subCategory) >= 0) {
              if ((<any>complianceArea).hasLevels) {
                anyWithLabel = true;
              }
              if (subCategory.subItems && subCategory.subItems.length) {
                anyWithLabel = anyWithLabel || (<any>complianceArea).hasLevels || subCategory.subItems.find(s => s.complianceArea.hasLevels);
                hasParents = true;
              }
            }
          }
        }
      }
    }

    this.hasParents = hasParents;
    this.hasLeveledSubItems = anyWithLabel;
  }

  updateRecommendedControls() {
    this.recommendedControlIds = this.selectedItProfile.flatMap(p => p.recommendedControlIds);
  }

  //TODO : Migration repeat
  updateLeveledSelection(repeat = true, update = true) {
    const selectedAreas = [];
    const levels = [];
    for (let complianceArea of this.complianceAreas) {
      if (!(<any> complianceArea).hasLevels) {
        continue;
      }
      let hasChildren = false;
      let anySelected = false;
      for (let category of complianceArea.children) {
        for (let subCategory of <any[]>category.children) {

          if (subCategory.children != null) {

            for (let controlItem of <any[]>subCategory.children) {
              if (this.selectedItems.indexOf(controlItem) >= 0) {
                anySelected = true;
              }
              if (controlItem.data.subItems && controlItem.data.subItems.length) {
                controlItem.data.subItems.forEach(s => {
                  if (s.level && levels.indexOf(s.level) < 0) {
                    levels.push(s.level);
                  }
                });
                hasChildren = true;
              }
              if (controlItem.data.level && levels.indexOf(controlItem.data.level) < 0) {
                levels.push(controlItem.data.level);
              }
            }
          }
          if (this.selectedItems.indexOf(subCategory) >= 0 && subCategory.data.controlItemId != 0) {

            if (this.selectedItems.indexOf(subCategory) >= 0) {
              anySelected = true;
            }
          }
          if (subCategory.subItems && subCategory.subItems.length) {
            subCategory.subItems.forEach(s => {
              if (s.level && levels.indexOf(s.level) < 0) {
                levels.push(s.level);
              }
            });
            hasChildren = true;
          }
          if (subCategory.level && levels.indexOf(subCategory.level) < 0) {
            levels.push(subCategory.level);
          }
        }
      }
      if (anySelected) {
        selectedAreas.push(complianceArea);
      }
    }

    if (update) {
      for (let complianceArea of selectedAreas) {
        for (let category of complianceArea.children) {
          for (let subCategory of <any[]>category.children) {
            if (subCategory.children != null) {
              for (let controlItem of <any[]>subCategory.children) {
                if (controlItem.level <= this.maxLevel) {
                  if (this.selectedItems.indexOf(controlItem) < 0) {
                    this.selectedItems = this.selectedItems.concat([controlItem]);
                  }
                } else {
                  this.selectedItems = this.selectedItems.filter(i => i != controlItem);
                }
              }
            }
            if (subCategory.data.controlItemId != 0) {
              if (subCategory.level <= this.maxLevel) {
                if (this.selectedItems.indexOf(subCategory) < 0) {
                  this.selectedItems = [...this.selectedItems.concat([subCategory])];
                  console.log(this.selectedItems);
                }
              } else {
                this.selectedItems = this.selectedItems.filter(i => i != subCategory);
              }
            }
          }
        }
        complianceArea.children = [...complianceArea.children];
      }
      this.initSelection(this.complianceAreas);
    }

    this.levels = levels.sort();

    if (repeat !== false) {
      setTimeout(() => this.updateLeveledSelection(false), 0);
    }
    this.updateAssignedUsers();
  }
}
